import { components, GroupBase, ValueContainerProps } from 'react-select'

import { AstraChip } from '../../../AstraChip/AstraChip'
import { SelectOption } from '../../AstraSelect'
import { useChipOverflow } from '../hooks/useChipOverflow'

export type AstraMultiSelectMultiValueContainerProps<T> = ValueContainerProps<SelectOption<T>, true, GroupBase<SelectOption<T>>>

export const AstraMultiSelectMultiValueContainer = <T,>({ children, ...rest }: AstraMultiSelectMultiValueContainerProps<T>) => {
    const { containerRef, counterRef, hiddenCount } = useChipOverflow()

    return (
        <div ref={containerRef} className="flex w-full min-w-0 items-center overflow-hidden !pl-0">
            <components.ValueContainer {...rest}>{children}</components.ValueContainer>
            {hiddenCount > 0 && (
                <div className="relative flex items-center before:pointer-events-none before:absolute before:bottom-0 before:left-[-20px] before:top-0 before:-my-1 before:w-[20px] before:bg-[linear-gradient(to_right,rgba(255,255,255,0)_0%,#ffffff_70%,#ffffff_100%)]">
                    <AstraChip ref={counterRef} size="small" variant="filled" color="default-interactive" onClick={() => {}} label={`+${hiddenCount}`} />
                </div>
            )}
        </div>
    )
}
